import morphism, { createSchema } from 'morphism';

const settingSchema = {
  allowPremiumDates: 'allowPremiumDates',
  acceptanceDurationInHours: 'acceptanceDurationInHours',
  disableReGifting: 'disableReGifting',
  disableScratchEffect: 'disableScratchEffect',
  earlyDeliveryInDays: 'earlyDeliveryInDays',
  occasionScheduleDuration: 'occasionScheduleDuration'
};

const automationBaseSchema = {
  name: 'name',
  type: 'type',
  contacts: source => {
    if (!source.contacts) return undefined;

    return source?.contacts?.ids?.length > 0
      ? { ids: source?.contacts?.ids, tags: [] }
      : { tags: source?.contacts?.tags, ids: [] };
  },
  products: source => {
    return source.products?.length
      ? source.products.map(product => ({
          id: product.merchantProductId,
          images:
            product?.images?.map(image => ({
              default: image?.default,
              full: image?.full,
              thumb: image?.thumb,
              url: image?.url
            })) || undefined,
          source: product?.source || undefined,
          name: product?.name,
          brand: product?.brand,
          merchantProductId: product.merchantProductId,
          prices: product.prices,
          skus: product.skus?.map(sku => ({
            code: sku.code,
            price: sku.price,
            priceBreakdown: sku.priceBreakdown
          })),
          meta: {
            productType: product?.meta?.productType
          }
        }))
      : undefined;
  },
  experienceSettings: source =>
    source.experienceSettings
      ? {
          ...source.experienceSettings,
          occasion: source.experienceSettings?.occasion || undefined,
          branding: source.experienceSettings?.branding?.giftWrapperUrl
            ? source.experienceSettings?.branding
            : undefined,
          messageParams: Object.keys(source.experienceSettings?.messageParams || {}).length
            ? {
                message: source.experienceSettings.messageParams?.message || undefined,
                senderName: source.experienceSettings.messageParams?.senderName || undefined,
                aboutMessage: source.experienceSettings.messageParams?.aboutMessage || undefined,
                customizedRecipientMessages:
                  Object.keys(
                    source.experienceSettings.messageParams?.customizedRecipientMessages || {}
                  ).length > 0
                    ? source.experienceSettings.messageParams?.customizedRecipientMessages
                    : undefined
              }
            : undefined,
          sharingMethod: Object.keys(source.experienceSettings?.sharingMethod || {}).length
            ? {
                params: {
                  subject: source.experienceSettings.sharingMethod?.params?.subject || undefined
                }
              }
            : undefined
        }
      : undefined,
  settings: source => morphism(settingSchema, source.settings),
  paymentMethod: source =>
    source?.paymentMethod
      ? {
          code: source.paymentMethod.code,
          name: source.paymentMethod.name,
          type: source.paymentMethod.type,
          meta: source.paymentMethod.meta
        }
      : undefined,
  meta: 'meta',
  addons: 'addons'
};

const create = createSchema(
  {
    ...automationBaseSchema
  },
  { undefinedValues: { strip: true } }
);

const update = createSchema(
  {
    ...automationBaseSchema,
    status: 'status'
  },
  { undefinedValues: { strip: true } }
);

const duplicate = createSchema(
  {
    name: 'name',
    options: {
      includeProducts: 'includeGifts',
      includeRecipients: 'includeRecipients',
      includeExperience: 'includeExperience'
    }
  },

  { undefinedValues: { strip: true } }
);

export default {
  create: createSchema(create, { undefinedValues: { strip: true } }),
  update: createSchema(update, { undefinedValues: { strip: true } }),
  duplicate: createSchema(duplicate, { undefinedValues: { strip: true } })
};
